export const FEATURE_KEYS = {
  CASHIA_WALLET: 'WP-9411-enable-cashia-integration',
  JACKPOT_MUST_BE_WON: 'SB-3076-enable-MustBeWon-jackpot',
  // add more KEYS here as needed i.e  WITHDRAWAL: 'WP-9500-enable-withdrawal-integration'
}
